<template>
  <a-modal
    title="进口报关信息"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :layout="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择项目' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="contractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="系统合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['system_contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="系统合同号"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              报关信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同协议号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['contract_protocol_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同协议号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="境外发货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['shipper', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="境外发货人"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="境内收货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['recipient', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="境内收货人"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="消费使用单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['consumer_use_location', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="消费使用单位"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="进口申报日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width: 100%"
                v-decorator="['declaration_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="申报日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="进境关别" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['customs_entry', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="进境关别"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="监管方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['supervision_mode', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="监管方式"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="货物存放地点" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['storage_location', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="货物存放地点"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="启运国（地区）" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['origin_country', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="启运国（地区）"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="货物名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['product_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="货物名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="商品编码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['product_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:50, message: '输入超出长度限制'}]}]" placeholder="商品编码"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="毛重" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" allow-clear v-decorator="['gross_weight', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="毛重"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="件数" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" allow-clear v-decorator="['quantity', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="件数"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" allow-clear v-decorator="['count', {initialValue: 1, rules: [{required: true, message: '必填项，请填写信息'}]}]">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" allow-clear v-decorator="['unit_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" allow-clear v-decorator="['total_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="总价"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :not-found-content="null"
                :default-active-first-option="false"
                v-decorator="['unit', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit" :label="val">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="原产国" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['country_of_origin', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="原产国"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="报关单号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['customs_declaration_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="报关单号"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="征免" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['levy_exemption_type', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="征免"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea :autosize="{minRows:1,maxRows:4}" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="备注"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开启审批" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl"></component>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { project_list } from '@/api/trade_project'

// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  name: 'CustomsDeclarationInfoForm',
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      formLayout: 'horizontal',
      sellContractList: [],
      otherData: {
        attachment: []
      },
      form: this.$form.createForm(this),
      projectFetching: false,
      contractFetching: false,
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      visibleFrom: false,
      currentComponent: '',
      confirmLoadingFrom: false,
      mdl: {},
      attachmentColumns: [
        {
          title: '名称',
          width: 150,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    // this.$watch('model', () => {
    //   this.model && this.form.setFieldsValue(pick(this.model, fields))
    // })
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleSellContractSearch () {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.contractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999, type: 1 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.contractFetching = false
      })
    },
    handleSellContractChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleSellContractSearch(value)
      }
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      this.mdl = {}
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            const current_date = new Date()
            values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
            this.otherData.attachment.push(values)
          }
          this.visibleFrom = false
          form.resetFields()
        } else {
          this.confirmLoading = false
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
